import Banner from '../../ui/Banner';
import { AllProjectsContainer, ProjectsList } from './styles';
import ProjectItem from '../ProjectItem';
import { Project, UploadFile } from '../../../types/schema';
import { formatSrcSet } from '../../../utils/formatURLs';

export type AllProjectsPageTemplateProps = {
  mainProjects: Project[];
  sideProjects: Project[];
  title?: string;
  language: string;
  bannerImg: string;
};

const AllProjectsPageTemplate: React.FC<AllProjectsPageTemplateProps> = ({
  mainProjects,
  sideProjects,
  language,
  bannerImg,
}) => {
  const isEn = language === 'en';
  mainProjects.sort((a, b) => {
    return +b.publicationDate - +a.publicationDate;
  });
  sideProjects.sort((a, b) => {
    return +b.publicationDate - +a.publicationDate;
  });
  return (
    <div style={{ width: '100%' }}>
      <Banner title={isEn ? 'Our Projects Done' : 'Projetos Realizados'} bannerImg={bannerImg} />

      <AllProjectsContainer>
        <h2>{isEn ? 'Client projects' : 'Projetos de clientes'}</h2>
        <span>
          {isEn
            ? 'Some projects are under NDA so they cannot be listed.'
            : 'Alguns projetos não podem ser divulgados, os demais apresentamos aqui.'}
        </span>
        <ProjectsList>
          {mainProjects.map((project) => (
            <ProjectItem
              thumbnailImage={formatSrcSet(
                project.thumbnailImage as UploadFile,
                'projectThumbnail',
              )}
              language={language}
              key={project.slug}
              project={project}
            />
          ))}
        </ProjectsList>
        <h2>{isEn ? 'Internal projects' : 'Projetos internos'}</h2>
        <span>
          {isEn
            ? 'Projects developed with the intent of studying, training new employees or just for fun.'
            : 'Projetos que desenvolvemos para fins de estudos, validar alguma tecnologia ou apenas por diversão.'}
        </span>
        <ProjectsList>
          {sideProjects.map((project) => (
            <ProjectItem
              thumbnailImage={formatSrcSet(
                project.thumbnailImage as UploadFile,
                'projectThumbnail',
              )}
              language={language}
              key={project.slug}
              project={project}
            />
          ))}
        </ProjectsList>
      </AllProjectsContainer>
    </div>
  );
};

export default AllProjectsPageTemplate;
